module.exports = __webpack_public_path__ + "static/media/bennett_lombardia.c487a528.gif";